// Styles for CustomTitleText go here.
import styled from 'styled-components';

export const StyledCustomTitleText = styled.div``;
